import { useId } from "react";
import { RightLaurelLeafDesktop } from "./right-laurel-leaf-desktop.component";

type RightLaurelLeafProps = {
	width?: string;
	height?: string;
	size?: "xs" | "xs-mobile" | "sm" | "md";
	className?: string;
};

export function RightLaurelLeaf({
	width = "25px",
	height = "49px",
	size,
	className,
}: RightLaurelLeafProps) {
	const id = useId().replace(/:/g, "_");
	const usesCssVarSize = width.includes("var(") || height.includes("var(");
	const svgStyle = usesCssVarSize ? { width, height } : undefined;

	if (size === "xs" || size === "xs-mobile") {
		return (
			<RightLaurelLeafDesktop
				width={width}
				height={height}
				className={className}
			/>
		);
	}

	const clipPathId = `clip0_${id}`;
	const gradientId = `paint0_linear_${id}`;

	return (
		<svg
			width={usesCssVarSize ? undefined : width}
			height={usesCssVarSize ? undefined : height}
			viewBox="0 0 25 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={svgStyle}
			aria-hidden="true"
		>
			<g clipPath={`url(#${clipPathId})`}>
				<path
					d="M23.5397 18.1118C23.3479 18.1135 23.1132 18.2548 22.9396 18.3563C19.812 20.1799 17.5547 23.4922 16.9645 27.1259C17.0579 25.6533 17.1513 24.1807 17.2439 22.7081C17.2794 22.1414 17.3381 21.3285 17.5712 20.8507C17.8043 20.3728 18.2862 19.971 18.7118 19.4753C21.3725 16.377 21.8163 11.4915 19.7376 7.9517C19.6872 7.86543 19.5301 7.69372 19.4499 7.63536C19.0102 7.31902 18.6821 7.85866 18.4399 8.25536C16.7281 11.0576 15.9834 14.4655 16.3644 17.7473C15.6726 16.2197 14.9643 14.6016 15.1131 12.9244C15.1825 12.1445 15.4371 11.3934 15.5891 10.6161C16.3281 6.85973 14.3014 2.70923 10.8944 1.09623C10.8547 1.07762 10.8109 1.06747 10.7671 1.06578C10.2918 1.05224 10.2422 1.40326 10.2265 1.70184C10.0827 4.4305 10.7183 7.19722 12.0358 9.57485C10.8952 8.41183 10.4522 7.9018 9.62811 6.48587C8.80487 5.06995 8.33374 3.00865 6.73603 1.81265C4.10183 -0.158143 0.898141 -0.157297 0.65431 0.170886C0.24765 0.718986 1.72551 4.1353 4.61594 6.02236C5.80864 6.80137 7.57662 7.4036 8.83132 8.0735C10.086 8.7434 11.2986 9.66282 11.8656 10.9891C9.68101 9.50888 6.94266 8.90918 4.35723 9.34479C4.17787 9.37524 3.97289 9.42514 4.01917 9.76348C4.02165 9.78039 4.02744 9.79731 4.0357 9.81169C5.745 12.7653 8.78503 14.8681 12.097 15.401C12.8872 15.5278 13.7592 15.6014 14.3303 16.1749C14.7411 16.5868 14.9122 17.1823 15.0544 17.7524C15.5272 19.6496 15.8487 21.5857 16.0148 23.5362C15.4602 20.5749 13.1616 18.0298 10.3208 17.2305C10.1687 17.1882 9.98848 17.1061 9.86202 17.2965C9.79755 17.392 9.82813 17.853 9.83392 17.9697C9.99261 21.3429 11.4407 24.3296 13.8542 26.6319C14.4105 27.1623 15.0519 27.7112 15.1734 28.4792C15.2437 28.925 15.1221 29.3775 14.9874 29.808C14.2749 32.0765 13.1384 34.2038 11.6581 36.0435C13.126 33.2083 12.9971 29.572 11.3118 26.8628C11.2242 26.7224 11.077 26.4856 10.9266 26.4222C10.6307 26.297 10.367 26.6801 10.2042 26.9212C8.32795 29.7048 7.65845 33.3098 8.4073 36.6034C8.57178 37.3275 8.79991 38.093 8.56104 38.795C8.35688 39.393 7.85021 39.8227 7.34684 40.1923C5.51605 41.5363 3.48357 42.4228 1.31472 43.0106C0.884916 43.1273 0.833671 43.1248 0.811354 43.1815C0.671668 43.5393 1.35026 44.4841 1.4635 44.4798C1.73956 44.4705 3.42902 43.9622 4.11836 43.8269C5.10608 43.6323 6.08306 44.1153 7.03689 44.4418C10.8225 45.7384 15.0891 44.7006 17.6406 41.4822C17.6456 41.4763 17.6489 41.4687 17.6514 41.4619C17.8026 41.0001 17.3654 40.907 17.0571 40.8081C14.0799 39.8497 10.7522 40.0815 7.92873 41.4441C9.30906 40.6778 10.2348 39.1892 11.6796 38.5599C12.6822 38.1234 13.8104 38.1555 14.8907 38.0134C18.5035 37.5364 21.7593 34.8703 22.9942 31.361C23.0297 31.2595 23.1148 30.8594 23.1132 30.752C23.1057 30.0465 22.1693 30.2411 21.5485 30.3603C18.525 30.9431 15.7272 32.6796 13.8253 35.1537C14.4121 33.9653 14.9982 32.776 15.585 31.5877C15.8074 31.136 16.0264 30.4974 16.5165 30.11C17.1125 29.6389 17.5166 29.6355 18.1192 29.3631C22.0296 27.5962 24.5175 22.994 23.8753 18.6633C23.8587 18.5542 23.7819 18.1085 23.5372 18.111L23.5397 18.1118Z"
					fill={`url(#${gradientId})`}
				/>
				<path
					d="M2.49988 1.57837C3.6091 2.19752 4.69105 2.87419 5.67381 3.69295C6.65574 4.51679 7.42939 5.54786 8.34272 6.44275C8.22287 6.33787 8.10302 6.23299 7.98565 6.12472C7.16655 5.36939 6.46068 4.49311 5.59942 3.78515C4.63071 2.96131 3.55703 2.27787 2.5007 1.57837H2.49988Z"
					fill="#E55C3C"
				/>
				<path
					d="M11.2844 2.33374C13.1251 4.55151 14.1591 7.44426 14.1897 10.3514C14.1914 10.7667 14.1782 11.1812 14.1401 11.5931C14.1517 11.1795 14.1534 10.765 14.1327 10.3531C14.0178 7.46118 12.9979 4.63356 11.2852 2.33374H11.2844Z"
					fill="#E55C3C"
				/>
			</g>
			<defs>
				<linearGradient
					id={gradientId}
					x1="10.8473"
					y1="22.4966"
					x2="22.2792"
					y2="22.4966"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F87D55" />
					<stop offset="0.72" stopColor="#FA8861" />
				</linearGradient>
				<clipPath id={clipPathId}>
					<rect width="25" height="45" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
